/**
 * radioSelect is an alternative select widget, where options are radio buttons 
 * which are always visible (instead of drop down like other select widgets).
 * 
 * Note: radioSelect is not a full replacement for selects, it does not support disabled options,
 *  optgroups, or multiple selection.
 *  
 * Usage:
 *   $('#select1').radioSelect();
 */
var instanceCount = 0;
(function($) {
	$.widget('ui.radioSelect', {
		
		options: {
			render: this._render,
			renderOptionDetails: this._renderOptionDetails
		},
		
		container: null,
		myInstanceNum: null,
		
		_create: function() {
			var self = this;
			// place container
			this.container = $('<div class="ui-radioselect"></div>');
			this.element.after(this.container);
			// copy classes so we can style it
			var classes = this.element.attr('class') ? this.element.attr('class').split(/\s+/) : [];
			$(classes).each(function(){
				self.container.addClass(this+'--radioselect');
			});
			// bind listeners
			this.element.bind('change refresh', function(event, otherParams){
				var f = self._render;
				var fOptionDetails = self._renderOptionDetails;
				if($.isFunction(self.options.render)) f = self.options.render;
				if($.isFunction(self.options.renderOptionDetails)) fOptionDetails = self.options.renderOptionDetails;
				self.container.children().remove();
				self.container.append(f(self.element, fOptionDetails));
			});
			this.element.hide();
			myInstanceNum = instanceCount;
			instanceCount++;
			// initial render
			this.element.trigger('refresh');
		},

		/**
		 * @return DOM elements
		 */
		_render: function(select, optionDetailsRenderFunction){
			var newSelect = $('<div></div>');
			$.each(select.find('option:not(:disabled)'), function(){
				var option = $(this);
				var optionDetailsHtml = optionDetailsRenderFunction(option);
				var newOption = $('<div class="ui-radioselect-option'+(option.is(':selected')?' selected':'')+'"><div class="radio-wrapper"></div><div class="option-text">'+option.text()+'</div><div class="option-details">'+optionDetailsHtml+'</div></div>');
				var radio = $('<input type="radio" name="ui-radioselect-radio-'+myInstanceNum+'" '+(option.is(':selected')?' checked="checked"':'')+'/>');
				newOption.find('.radio-wrapper').append(radio);
				newOption.click(function(){
					radio.attr('checked', 'checked').change();;
				});
				radio.change(function(){
					option.attr('selected', 'selected').change();
				});
				newSelect.append(newOption);
			});
			return newSelect;
		},
		
		_renderOptionDetails: function(option){
			return '';
		}
		
	});
})(jQuery);